import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const getUsersMeOrganisationsCurrentDashboardsPossibleWidgetsSelector =
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentDashboardsPossibleWidgets.select(
    {},
  );
